// Local chat responses for Icedream Global
// All keywords and responses customized for the website

const WEBSITE_DETAILS = {
  name: 'Icedream Global',
  phone: '(+91) 9873578910',
  email: 'support@icedreamglobal.com',
  website: 'https://icedreamglobal.com',
  facebook: 'https://www.facebook.com/share/yhbpDtnYReppzRBs/?mibextid=qi2Omg',
  linkedin: 'https://www.linkedin.com/company/icedream-global/',
  instagram: 'https://www.instagram.com/icedreamglobal?igsh=bjU1am1mdTZ3bHNt',
  corporateOffice: 'C-8/2 GF, Vasant Vihar, New Delhi - 110057',
  factoryAddress: 'Newryan Global Private Limited, Plot No. 74-75, AKVN, Growth Center, Malanpur, Industrial Area, Bhind-477001, Madhya Pradesh, India',
  tagline: 'Top global exporter of frozen potatoes and shrimps.',
  description: 'Icedream Global is a leading frozen food exporter specializing in premium quality potatoes and shrimps. With state-of-the-art facilities and strict quality controls, we deliver excellence globally.',
};

const KEYWORDS = {
  GREETING: ['hello', 'hi', 'hey', 'good morning', 'good evening', 'good afternoon'],
  CONTACT: ['contact', 'email', 'phone', 'call', 'reach', 'connect'],
  LOCATION: ['location', 'factory', 'office', 'where', 'address', 'map', 'directions', 'corporate', 'registered', 'headquarter', 'head office', 'plant', 'site', 'site address', 'factory address', 'office address'],
  FROZEN_SHRIMPS: ['frozen shrimps', 'frozenshrimp', 'frozen shrimp', 'frozen shrimps', 'shrimp export', 'shrimp products'],
  FROZEN_POTATOES: ['frozen potatoes', 'frozenpotatoes', 'frozen potato', 'potato export', 'potato product'],
  VALUE_ADDED: ['value added', 'value added products', 'value added snacks', 'value added shrimp', 'value added potatoes', 'value added potatoflakes'],
  POTATO_FLAKES: ['potato flakes', 'potatoflakes', 'flakes'],
  POTATO_PROCESSING: ['potato processing', 'potato plant', 'potato manufacturing', 'potato production', 'potato facility', 'potato processing plant'],
  SHRIMPS_PROCESSING: ['shrimp processing', 'shrimps processing', 'shrimp facility', 'shrimp manufacturing', 'shrimp production', 'shrimp plant', 'shrimp cold storage'],
  PRODUCTS: ['product', 'shrimp', 'potato', 'frozen', 'fries', 'offer', 'item'],
  ABOUT: ['about', 'company', 'who', 'history', 'overview', 'background', 'mission', 'vision'],
  INFRASTRUCTURE: ['infrastructure', 'facility', 'plant', 'processing', 'equipment', 'technology'],
  QUALITY: ['quality'],
  CAREERS: ['career', 'job', 'opportunity', 'recruitment', 'hire', 'position', 'work', 'apply'],
  CERTIFICATIONS: ['certified', 'certificate' ,'certificates' , 'certification', 'haccp', 'iso 22000', 'standard', 'audit', 'brc', 'bap', 'fda', 'eu'],
  BLOG: ['blog', 'article', 'news', 'update', 'read'],
  PRIVACY: ['privacy', 'policy', 'data', 'gdpr'],
  TERMS: ['terms', 'condition', 'legal', 'agreement'],
  VISION: ['vision', 'mission', 'goal', 'objective', 'future'],
  GLOBAL: ['global', 'international', 'world', 'export', 'market'],
  QUALITY_DRIVEN: ['quality driven', 'quality', 'driven', 'excellence'],
  CUSTOMER: ['customer', 'client', 'feedback', 'satisfaction'],
  BACKWARD_INTEGRATION: ['backward integration', 'integration', 'supply', 'chain'],
  PRICING: ['product price', 'products price','price', 'pricing', 'cost', 'budget', 'billing', 'invoice', 'quote', 'quotation', 'rates', 'rate', 'charges', 'fee'],
  POTATOES: ['potato', 'potatoes', 'fries', 'french fries', 'wedges', 'hash brown', 'hash browns', 'burger patty', 'potato burger patty', 'herb and chilli burger patty', 'tikki', 'potato flakes', 'frozen potatoes', 'potato wedges'],
  SHRIMP: ['shrimp', 'shrimps', 'seafood', 'breaded', 'breaded shrimp', 'breaded shrimp torpedo', 'breaded shrimp filo', 'breaded butterfly', 'breaded butterfly shrimp', 'frozen shrimps', 'torpedo', 'butterfly', 'filo'],
  PROCESSING: ['processing', 'process', 'manufacturing', 'production'],
  SOCIAL: ['social', 'facebook', 'instagram', 'linkedin', 'follow', 'connect', 'media'],
};

const STOP_WORDS = [
  'the', 'a', 'an', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'is', 'are', 'be',
  'have', 'has', 'do', 'does', 'did', 'will', 'would', 'should', 'could', 'may', 'might',
];

// Static pages data for knowledge base
const STATIC_PAGES = [
  {
    path: '/',
    title: 'Home',
    summary: 'Welcome to Icedream Global, leading exporter of frozen potatoes and shrimps',
    keywords: ['home', 'welcome', 'icedream', 'global', 'frozen', 'food', 'exporter'],
  },
  {
    path: '/about',
    title: 'About Us',
    summary: 'Learn about Icedream Global - our mission, vision, quality driven approach, customer focus, backward integration, global presence, and the advantages of choosing Icedream.',
    keywords: ['about', 'mission', 'vision', 'company', 'history', 'overview', 'background', 'advantage icedream', 'our global presence', 'global presence', 'quality', 'customer', 'integration', 'proudly made', 'expert team', 'technological innovation'],
  },
  {
    path: '/infrastructure',
    title: 'Infrastructure',
    summary: 'Our state-of-the-art infrastructure includes HACCP-compliant processing facilities, ISO 22000 certified plants, BRC certified, BAP certified, FDA approved packing units, EU approved units, EIA approved labs, and standardized grading facilities',
    keywords: ['infrastructure', 'facility', 'processing', 'haccp', 'iso', 'certification', 'plant', 'equipment', 'technology', 'potato processing', 'shrimp processing', 'lab', 'grading'],
  },
  {
    path: '/product',
    title: 'Products',
    summary: 'Explore our product categories: Frozen Shrimps, Frozen Potatoes, and Value Added Products including Shrimps, Potatoes, and Potato Flakes.',
    keywords: ['product', 'frozen shrimp', 'frozen potato', 'value added', 'value added products', 'shrimp products', 'potato products', 'potato flakes'],
  },
  {
    path: '/shrimpsprocessing',
    title: 'Shrimps Processing',
    summary: 'Advanced shrimp processing facility with modern equipment, cold storage, and HACCP-compliant procedures.',
    keywords: ['shrimp processing', 'shrimp','process', 'processing', 'facility', 'cold storage', 'quality control', 'seafood'],
  },
  {
    path: '/potatoprocessing',
    title: 'Potato Processing',
    summary: 'State-of-the-art potato processing plant producing premium frozen potato products with hygiene, grading, and packaging systems.',
    keywords: ['potato processing', 'potato', 'process','processing', 'plant', 'production', 'grading', 'packaging', 'frozen potatoes'],
  },
  {
    path: '/frozenshrimp',
    title: 'Frozen Shrimps',
    summary: 'Frozen shrimps and breaded shrimp products made for export, including Breaded Shrimp Torpedo, Breaded Shrimp Filo, Breaded Butterfly, Butterfly Cut, Torpedo Cut, and Filo Wrapped Shrimp.',
    keywords: ['frozen shrimp', 'frozenshrimp', 'shrimp', 'butterfly', 'torpedo', 'filo', 'breaded', 'breaded shrimp torpedo', 'breaded shrimp filo', 'breaded butterfly', 'breaded butterfly shrimp'],
  },
  {
    path: '/frozenpotatoes',
    title: 'Frozen Potatoes',
    summary: 'Premium frozen potatoes for global export, including fries, wedges, burger patties, herb and chilli burger patty, potato burger patty, hash browns, and other frozen potato products.',
    keywords: ['frozen potatoes', 'frozenpotatoes', 'potatoes', 'fries', 'wedges', 'hash browns', 'hash brown', 'burger patties', 'potato burger patty', 'herb and chilli burger patty', 'potato wedges', 'potato flakes', 'frozen potato'],
  },
  {
    path: '/frenchfries',
    title: 'Value Added Products',
    summary: 'Value Added Products include shrimp snacks, potato snacks, potato flakes, herb and chilli burger patties, potato burger patties, and potato wedges.',
    keywords: ['value added products', 'value added snacks', 'shrimp snacks', 'potato snacks', 'potato flakes', 'french fries', 'frozen snacks', 'herb and chilli burger patty', 'potato burger patty', 'potato wedges'],
  },
  {
    path: '/shrimps',
    title: 'Shrimps',
    summary: 'Value added shrimp products offering quality seafood snacks and prepared shrimp varieties for export, including Breaded Shrimp Torpedo, Breaded Shrimp Filo, and Breaded Butterfly.',
    keywords: ['shrimps', 'shrimp products', 'shrimp snacks', 'breaded shrimp', 'breaded shrimp torpedo', 'breaded shrimp filo', 'breaded butterfly', 'breaded butterfly shrimp', 'butterfly shrimp', 'torpedo shrimp'],
  },
  {
    path: '/potatoes',
    title: 'Potatoes',
    summary: 'Value added potato products including Herb and Chilli Burger Patty, Potato Burger Patty, Potato Wedges, Hash Browns, and more.',
    keywords: ['potatoes', 'potato products', 'potato snacks', 'wedges', 'hash browns', 'hash brown', 'burger patties', 'potato burger patty', 'herb and chilli burger patty', 'potato wedges', 'tikki'],
  },
  {
    path: '/potatoflakes',
    title: 'Potato Flakes',
    summary: 'Potato flakes made from premium potatoes for industrial and food processing use.',
    keywords: ['potato flakes', 'potatoflakes', 'potato', 'flakes', 'processed potato', 'food industry'],
  },
  {
    path: '/quality',
    title: 'Quality',
    summary: 'Our commitment to quality includes rigorous testing, quality assurance, international certifications, and continuous improvement processes',
    keywords: ['quality', 'assurance', 'testing', 'certification', 'standard', 'excellence', 'process', 'driven'],
  },
  {
    path: '/contactus',
    title: 'Contact Us',
    summary: 'Get in touch with Icedream Global for inquiries, orders, or partnership opportunities',
    keywords: ['contact', 'email', 'phone', 'address', 'inquiry', 'reach', 'location'],
  },
  {
    path: '/careers',
    title: 'Careers',
    summary: 'Join our team! Current job opportunities in various departments including sales, HR, and operations',
    keywords: ['careers', 'job', 'opportunity', 'recruitment', 'position', 'apply', 'work', 'sales', 'hr', 'management'],
  },
  {
    path: '/blog',
    title: 'Blog',
    summary: 'Latest news, updates, and articles about frozen food industry and Icedream Global',
    keywords: ['blog', 'article', 'news', 'update', 'industry', 'information'],
  },
  {
    path: '/privacypolicy',
    title: 'Privacy Policy',
    summary: 'Learn about how Icedream Global protects your privacy and data',
    keywords: ['privacy', 'policy', 'data', 'protection', 'gdpr'],
  },
  {
    path: '/termsandcondition',
    title: 'Terms and Conditions',
    summary: 'Read the terms and conditions for using Icedream Global website and services',
    keywords: ['terms', 'conditions', 'legal', 'agreement', 'policy'],
  },
];

// Certifications data
const CERTIFICATIONS = [
  'HACCP-Compliant Processing Facility',
  'ISO 22000 Certified',
  'BRC Certified',
  'BAP Certified',
  'FDA-Approved A list packer',
  'EU-Approved Unit',
  'EIA-Approved Lab Technologists',
  'Sophisticated lab facility',
  'Standardised grading & weighment facility',
];

// Products list
const PRODUCTS_LIST = [
  { name: 'Frozen Potatoes', category: 'Frozen Potatoes', link: '/frozenpotatoes' },
  { name: 'French Fries', category: 'Value Added', link: '/frenchfries' },
  { name: 'Potato Wedges', category: 'Potatoes', link: '/potatoes' },
  { name: 'Burger Patties', category: 'Potatoes', link: '/potatoes' },
  { name: 'Hash Browns', category: 'Potatoes', link: '/potatoes' },
  { name: 'Aloo Tikki', category: 'Potatoes', link: '/potatoes' },
  { name: 'Potato Flakes', category: 'Value Added', link: '/potatoflakes' },
  { name: 'Frozen Shrimps', category: 'Frozen Shrimps', link: '/frozenshrimp' },
  { name: 'Breaded Shrimps', category: 'Frozen Shrimps', link: '/frozenshrimp' },
  { name: 'Butterfly Cut Shrimp', category: 'Frozen Shrimps', link: '/frozenshrimp' },
  { name: 'Torpedo Shrimp', category: 'Frozen Shrimps', link: '/frozenshrimp' },
  { name: 'Filo Wrapped Shrimp', category: 'Frozen Shrimps', link: '/frozenshrimp' },
];

const SOCIAL_LINKS = [
  { title: 'Facebook', href: WEBSITE_DETAILS.facebook },
  { title: 'LinkedIn', href: WEBSITE_DETAILS.linkedin },
  { title: 'Instagram', href: WEBSITE_DETAILS.instagram },
];

// Careers list
const CAREERS_LIST = [
  { title: 'Area Sales Manager', category: 'Sales', link: '/careers' },
  { title: 'Sales Executive', category: 'Sales', link: '/careers' },
  { title: 'Senior Sales Executive', category: 'Sales', link: '/careers' },
  { title: 'Senior HR Manager', category: 'HR', link: '/careers' },
];

// Helper function to detect intent
function detectIntent(question) {
  const lowerQ = question.toLowerCase();

  for (const [intent, keywords] of Object.entries(KEYWORDS)) {
    for (const keyword of keywords) {
      if (lowerQ.includes(keyword)) {
        return intent;
      }
    }
  }

  return 'GENERAL';
}

// Helper function to score pages based on question
function scorePages(question) {
  const tokens = question
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .split(/\s+/)
    .filter((word) => word.length > 2 && !STOP_WORDS.includes(word));

  const scores = STATIC_PAGES.map((page) => {
    let score = 0;

    // Title matching (highest priority)
    tokens.forEach((token) => {
      if (page.title.toLowerCase().includes(token)) score += 5;
    });

    // Summary matching
    tokens.forEach((token) => {
      if (page.summary.toLowerCase().includes(token)) score += 2;
    });

    // Keywords matching
    page.keywords.forEach((keyword) => {
      tokens.forEach((token) => {
        if (keyword.includes(token) || token.includes(keyword.substring(0, 3))) {
          score += 3;
        }
      });
    });

    return { ...page, score };
  });

  return scores.filter((p) => p.score > 0).sort((a, b) => b.score - a.score);
}

// Local response function
export function getLocalResponse(question) {
  if (!question.trim()) {
    return {
      answer: "Could you please ask your question again?",
      links: [],
      needsClarification: true,
    };
  }

  const lowerQ = question.toLowerCase();
  const pricingKeywords = ['price', 'pricing', 'cost', 'budget', 'billing', 'invoice', 'quote', 'quotation', 'rates', 'rate', 'charges', 'fee'];
  const isPricingQuery = pricingKeywords.some((keyword) => lowerQ.includes(keyword));

  if (isPricingQuery) {
    return {
      answer: 'For pricing, budget, or billing details, we tailor quotes to your exact product, quantity, and delivery needs. Please contact us so we can discuss your requirements and provide a personalized proposal.',
      links: [{ title: 'Contact Us', href: '/contactus' }],
    };
  }

  const intent = detectIntent(question);

  // Greeting
  if (intent === 'GREETING') {
    return {
      answer: `Welcome! I'm here to help with information about Icedream Global's products, services, and more. How can I assist you?`,
      links: [{ title: 'Explore Products', href: '/product' }],
    };
  }

  // Contact
  if (intent === 'CONTACT') {
    return {
      answer: `📞 Phone: ${WEBSITE_DETAILS.phone}\n📧 Email: ${WEBSITE_DETAILS.email}\n\nWe're here to help!`,
      links: [{ title: 'Contact Us', href: '/contactus' }],
    };
  }

  // Pricing / Billing
  if (intent === 'PRICING') {
    return {
      answer: 'For pricing, budget, or billing details, we tailor quotes to your exact product, quantity, and delivery needs. Please contact us so we can discuss your requirements and provide a personalized proposal.',
      links: [{ title: 'Contact Us', href: '/contactus' }],
    };
  }

  // Location/Factory/Office
  if (intent === 'LOCATION') {
    const wantsFactory = lowerQ.includes('factory') || lowerQ.includes('plant') || lowerQ.includes('industrial') || lowerQ.includes('site') || lowerQ.includes('manufacturing') || lowerQ.includes('factory address');
    const wantsOffice = lowerQ.includes('office') || lowerQ.includes('corporate') || lowerQ.includes('registered') || lowerQ.includes('head office') || lowerQ.includes('headquarter') || lowerQ.includes('office address');

    if (wantsFactory && !wantsOffice) {
      return {
        answer: `🏭 Factory Address:\n${WEBSITE_DETAILS.factoryAddress}`,
        links: [{ title: 'Contact Us', href: '/contactus' }],
      };
    }

    if (wantsOffice && !wantsFactory) {
      return {
        answer: `🏢 Corporate Office Address:\n${WEBSITE_DETAILS.corporateOffice}`,
        links: [{ title: 'Contact Us', href: '/contactus' }],
      };
    }

    return {
      answer: `🏢 Corporate Office Address:\n${WEBSITE_DETAILS.corporateOffice}\n\n🏭 Factory Address:\n${WEBSITE_DETAILS.factoryAddress}`,
      links: [{ title: 'Contact Us', href: '/contactus' }],
    };
  }

  // Frozen Shrimps
  if (intent === 'FROZEN_SHRIMPS' || lowerQ.includes('frozen shrimps') || lowerQ.includes('frozenshrimp')) {
    return {
      answer: 'Explore our Frozen Shrimps range, including Breaded Shrimp Torpedo, Breaded Shrimp Filo, Breaded Butterfly, Butterfly Cut, Torpedo Cut, and Filo Wrapped Shrimp.',
      links: [{ title: 'Frozen Shrimps', href: '/frozenshrimp' }],
    };
  }

  // Frozen Potatoes
  if (intent === 'FROZEN_POTATOES' || lowerQ.includes('frozen potatoes') || lowerQ.includes('frozenpotatoes')) {
    return {
      answer: 'Explore our Frozen Potatoes range, including fries, potato wedges, burger patties, hash browns, Herb and Chilli Burger Patty, and Potato Burger Patty.',
      links: [{ title: 'Frozen Potatoes', href: '/frozenpotatoes' }],
    };
  }

  // Value Added Products
  if (intent === 'VALUE_ADDED' || lowerQ.includes('value added') || lowerQ.includes('valueadded')) {
    return {
      answer: 'Discover our Value Added Products category with Shrimps, Potatoes, and Potato Flakes, including shrimp snacks, potato snacks, and premium potato flakes.',
      links: [{ title: 'Value Added Products', href: '/frenchfries' }],
    };
  }

  // Shrimp category page
  if (intent === 'SHRIMP' || lowerQ.includes('shrimps')) {
    return {
      answer: 'Our Shrimp range includes Breaded Shrimp Torpedo, Breaded Shrimp Filo, Breaded Butterfly, and other value-added shrimp products designed for export.',
      links: [{ title: 'Shrimps', href: '/shrimps' }],
    };
  }

  // Potato category page
  if (intent === 'POTATOES' && !lowerQ.includes('frozen potatoes')) {
    return {
      answer: 'Our Potato range includes Herb and Chilli Burger Patty, Potato Burger Patty, Potato Wedges, Hash Browns, and other value-added potato snacks.',
      links: [{ title: 'Potatoes', href: '/potatoes' }],
    };
  }

  // Potato Flakes
  if (intent === 'POTATO_FLAKES' || lowerQ.includes('potato flakes') || lowerQ.includes('potatoflakes')) {
    return {
      answer: 'Our Potato Flakes are produced for industrial and food processing use with premium quality standards.',
      links: [{ title: 'Potato Flakes', href: '/potatoflakes' }],
    };
  }

  // Products - General
  if (intent === 'PRODUCTS') {
    return {
      answer: 'We offer premium Frozen Shrimps, Frozen Potatoes, and Value Added Products. Explore the category that fits your needs.',
      links: [{ title: 'All Products', href: '/product' }],
    };
  }

  // About/Company
  if (intent === 'ABOUT') {
    if (lowerQ.includes('mission')) {
      return {
        answer: 'Our Mission: To deliver premium frozen food globally with unwavering commitment to quality and innovation.',
        links: [{ title: 'Learn More About Us', href: '/about' }],
      };
    } else if (lowerQ.includes('vision')) {
      return {
        answer: 'Our Vision: To be the world\'s most trusted frozen food exporter, known for excellence and reliability.',
        links: [{ title: 'About Us', href: '/about' }],
      };
    }
    return {
      answer: 'Icedream Global is a leading frozen food exporter with state-of-the-art facilities and strict quality standards.',
      links: [{ title: 'About Icedream Global', href: '/about' }],
    };
  }

  // Infrastructure
  if (intent === 'INFRASTRUCTURE') {
    if (lowerQ.includes('shrimp')) {
      return {
        answer: 'Our Shrimp Processing: HACCP-compliant, ISO 22000 certified, with advanced freezing and quality control systems.',
        links: [{ title: 'Infrastructure Details', href: '/infrastructure' }],
      };
    } else if (lowerQ.includes('potato')) {
      return {
        answer: 'Our Potato Processing: State-of-the-art equipment with standardized grading and BRC certification.',
        links: [{ title: 'Infrastructure Details', href: '/infrastructure' }],
      };
    }
    return {
      answer: 'We have two modern processing facilities with HACCP-compliant systems, ISO 22000 certification, and advanced equipment.',
      links: [{ title: 'View Infrastructure', href: '/infrastructure' }],
    };
  }

  // Potato Processing
  if (intent === 'POTATO_PROCESSING') {
    return {
      answer: 'Our Potato Processing facility is state-of-the-art, with HACCP-compliant production, standardized grading, and BRC certification for premium frozen potato products.',
      links: [{ title: 'Potato Processing', href: '/potatoprocessing' }],
    };
  }

  // Shrimps Processing
  if (intent === 'SHRIMPS_PROCESSING') {
    return {
      answer: 'Our Shrimps Processing unit follows strict HACCP and ISO 22000 standards, offering advanced shrimp cleaning, freezing, and packaging systems.',
      links: [{ title: 'Shrimps Processing', href: '/shrimpsprocessing' }],
    };
  }

  // Quality
  if (intent === 'QUALITY') {
    const shortCerts = [
      '✓ HACCP-Compliant',
      '✓ ISO 22000 Certified',
      '✓ BRC Certified',
      '✓ BAP Certified',
      '✓ FDA Approved',
      '✓ EU Approved',
    ].join('\n');
    return {
      answer: `Our Quality Standards:\n${shortCerts}\n\nWe maintain the highest international standards.`,
      links: [{ title: 'Quality Assurance', href: '/quality' }],
    };
  }

  // Certifications
  if (intent === 'CERTIFICATIONS') {
    return {
      answer: 'Our certifications are listed in the Our Certifications section on the Home page. Please visit the Home page to view the full list.',
      links: [{ title: 'Home', href: '/' }],
    };
  }

  // Careers
  if (intent === 'CAREERS') {
    return {
      answer: 'Join our team! We have opportunities in Sales (Area Sales Manager, Sales Executive) and HR Management.',
      links: [{ title: 'View Career Opportunities', href: '/careers' }],
    };
  }

  // Social Media
  if (intent === 'SOCIAL' || lowerQ.includes('social') || lowerQ.includes('follow') || lowerQ.includes('connect')) {
    if (lowerQ.includes('facebook')) {
      return {
        answer: 'Follow us on Facebook for updates and news.',
        links: [{ title: 'Visit Facebook', href: WEBSITE_DETAILS.facebook }],
      };
    }
    if (lowerQ.includes('linkedin') || lowerQ.includes('linkdin')) {
      return {
        answer: 'Follow us on LinkedIn for company updates and business news.',
        links: [{ title: 'Visit LinkedIn', href: WEBSITE_DETAILS.linkedin }],
      };
    }
    if (lowerQ.includes('instagram')) {
      return {
        answer: 'Follow us on Instagram for product highlights and company stories.',
        links: [{ title: 'Visit Instagram', href: WEBSITE_DETAILS.instagram }],
      };
    }
    return {
      answer: 'Follow us on social media for updates, products, and company news.',
      links: SOCIAL_LINKS,
    };
  }

  // Blog
  if (intent === 'BLOG') {
    return {
      answer: 'Check our blog for latest industry news, product updates, and insights about frozen food.',
      links: [{ title: 'Read Our Blog', href: '/blog' }],
    };
  }

  // Privacy
  if (intent === 'PRIVACY') {
    return {
      answer: 'We take your privacy seriously and follow international data protection standards.',
      links: [{ title: 'Privacy Policy', href: '/privacypolicy' }],
    };
  }

  // Terms
  if (intent === 'TERMS') {
    return {
      answer: 'Please review our terms and conditions for website usage and services.',
      links: [{ title: 'Terms & Conditions', href: '/termsandcondition' }],
    };
  }

  // Fallback - score pages
  const scoredPages = scorePages(question);
  if (scoredPages.length > 0) {
    const topPage = scoredPages[0];
    const desc = topPage.summary.substring(0, 120) + '...';
    return {
      answer: desc,
      links: [{ title: topPage.title, href: topPage.path }],
    };
  }

  // Default
  return {
    answer: "I'm not sure about that. Please check our website or contact us for more information.",
    links: [{ title: 'Contact Us', href: '/contactus' }],
    needsClarification: true,
  };
}

export default { getLocalResponse, WEBSITE_DETAILS, STATIC_PAGES };
